import React, { useRef } from 'react';
import { Form, Container, Row, Col } from '/components/forms/form_element';
import Cookie from 'js-cookie';
import settings from '../settings';
import logo from '../assets/images/logo.png'
import {Button} from '/components/forms/save_button';
const roles = {
  admin: 'Administrator',
  ca: 'Credit Analyst',
  lo: 'Loan Officer',
  pm: 'Portfolio Manager',
  cco: 'Chief Credit Officer',
  clo: 'Chief Lending Officer',
}

export default props => {
  const loginFormRef = useRef();

  const handleSubmit = evt => {
    evt.preventDefault();

    const token = settings.getTestToken(roles[
      loginFormRef.current.querySelector('#formGroupPassword').value
    ]);

    localStorage.setItem(settings.getLocalTokenName(), token);

    const url = sessionStorage.getItem('requestedURL');
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <div className="form-container">

      <div className="text-center">
        <div style={{
          height: '200px',
          background: `url(${logo}) center center no-repeat`,
          backgroundSize: 'contain'
        }}></div>
        <h3>IDP Login</h3>
      </div>

      <div ref={loginFormRef}>
        <Form className="login-form" onSubmit={handleSubmit}>
          <Container>
            <Row>
              <Col>
                <Form.Group controlId="formGroupEmail">
                  <Form.Label>E-mail address</Form.Label>
                  <Form.Control type="email" placeholder="Enter your e-mail address" />
                </Form.Group>
                <Form.Group controlId="formGroupPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" placeholder="Enter your password" />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <Button variant="primary" type="submit" block>Submit</Button>
              </Col>
              <Col className="text-center">
                <Button variant="secondary" type="reset" block>Clear</Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </div>
  )
}
